import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  BehaviorSubject,
  catchError,
  Observable,
  switchMap,
  take,
  throwError,
} from 'rxjs';
import { AuthService } from './auth.service';
import { LoadingService } from './shared/components/loading.service';
import { AuthStateService } from './auth-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private authService: AuthService,
    private authStateService: AuthStateService,
    private router: Router,
    private loadingService: LoadingService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {  
    return this.authStateService.sessionReady$.pipe(
      take(1),
      switchMap(() => {
        return next.handle(req).pipe(
          catchError((error) => {
            if (error.status === 401 && !this.isRefreshing) {
              this.isRefreshing = true;
              return this.authService.pingServer().pipe(
                switchMap(() => {
                  this.isRefreshing = false;
                  return next.handle(req); // retry original
                }),
                catchError((refreshError) => {
                  this.isRefreshing = false;
                  this.authService.logout();
                  return throwError(() => refreshError);
                }),
              );
            } else if (error.status === 401) {
              this.loadingService.setLoading(false);
              this.authService.logout();
              this.router.navigateByUrl('/auth/login');
            }
            return throwError(() => error);
          }),
        );
      })
    );
  }
}
